module.exports = __webpack_public_path__ + "static/fonts/fa-regular-400.f8836cf.woff2";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/fa-regular-400.woff2
// module id = N1oV
// module chunks = 13 14